import React from 'react';
import { GenericFormPage } from '../../../components/generic';
import { usePmsScheduleType, PmsScheduleType } from './useData';
import { moduleConfig, getInitialFormData, mapItemToFormData } from './config';

const Form: React.FC = () => (
  <GenericFormPage<PmsScheduleType>
    useData={usePmsScheduleType}
    config={{
      ...moduleConfig,
      getInitialFormData,
      mapItemToFormData,
    }}
  />
);

export default Form;
